import { useQuery } from "@tanstack/react-query";
import { useAdminSession } from "@/hooks/useAdminSession";
import {
  listAdminInventoryWarehouses,
  listAdminInventoryBalances,
  listAdminInventoryMovements,
} from "./inventory";

export function useAdminInventoryWarehouses(companyId: string | undefined) {
  const enabled = useAdminSession();
  return useQuery({
    queryKey: ["admin", "inventory", companyId, "warehouses"],
    enabled: enabled && !!companyId,
    queryFn: () => listAdminInventoryWarehouses(companyId!),
  });
}

export function useAdminInventoryBalances(
  companyId: string | undefined,
  params: { warehouseId?: string },
) {
  const enabled = useAdminSession();
  return useQuery({
    queryKey: ["admin", "inventory", companyId, "balances", params],
    enabled: enabled && !!companyId,
    queryFn: () => listAdminInventoryBalances(companyId!, params),
  });
}

export function useAdminInventoryMovements(
  companyId: string | undefined,
  params: { limit?: number },
) {
  const enabled = useAdminSession();
  return useQuery({
    queryKey: ["admin", "inventory", companyId, "movements", params],
    enabled: enabled && !!companyId,
    queryFn: () => listAdminInventoryMovements(companyId!, params),
  });
}